import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Seo from '@/components/base/Seo';
import ContactForm from './components/ContactForm';

const SITE_URL = 'https://www.manhuadao.cn';

const VALUES = [
  { icon: 'ri-eye-line', title: '专业把关', desc: '资深编辑团队审读每部作品，用专业眼光为你筛选值得入坑的好漫。' },
  { icon: 'ri-shield-star-line', title: '品质优先', desc: '我们只推荐经得起推敲的佳作，宁缺毋滥，让每一次发现都值得。' },
  { icon: 'ri-team-line', title: '真诚中立', desc: '坚持独立客观的推荐态度，不带偏见，只为帮读者找到真正的好作品。' },
  { icon: 'ri-flashlight-line', title: '持续挖掘', desc: '不断追踪新作与潜力佳作，让"发现好漫"这件事，每天都有新惊喜。' },
];

const TESTIMONIALS = [
  {
    name: '小鹿斑比',
    role: '漫画爱好者',
    text: '在漫画岛挖到了好几部冷门宝藏，编辑的眼光是真的准，从此追更有了方向。',
  },
  {
    name: '阿泽同学',
    role: '大学生',
    text: '每日推荐成了我每天的固定节目，跟着推荐入坑，几乎没有踩过雷，好评！',
  },
  {
    name: '南山南',
    role: '资深读者',
    text: '分类做得特别清晰，按口味挑选很方便，漫画岛的编辑精选值得信赖。',
  },
];

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于漫画岛',
    url: `${SITE_URL}/about`,
    description: '了解漫画岛的品牌故事、编辑理念、用户口碑与联系方式。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '漫画岛',
    url: SITE_URL,
    email: 'contact@manhuadao.cn',
    foundingDate: '2024',
    slogan: '发现好漫，追更从此有方向',
  },
];

export default function AboutPage() {
  return (
    <>
      <Seo
        title="关于我们 · 漫画岛 | 发现好漫频道"
        description="了解漫画岛的品牌故事与编辑理念。漫画岛发现好漫频道，编辑精选每日推荐热门新作与潜力佳作，口碑可信赖，欢迎通过联系我们表单与我们交流。"
        canonicalPath="/about"
        jsonLd={jsonLd}
      />
      <Navbar />

      <section className="relative flex min-h-[420px] items-center justify-center overflow-hidden pt-16 md:h-[480px]">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20an%20open%20book%20glowing%20with%20warm%20light%20surrounded%20by%20floating%20manga%20panels%20and%20paper%20planes%2C%20warm%20amber%20coral%20and%20cream%20color%20palette%2C%20inspiring%20dreamy%20atmosphere%2C%20artistic%20digital%20illustration&width=1600&height=900&seq=about-banner&orientation=landscape"
          alt="关于漫画岛"
          title="关于漫画岛 - 品牌介绍"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/40 to-background-950/70"></div>
        <div className="relative z-10 mx-auto w-full max-w-4xl px-4 text-center md:px-6">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-background-950/40 px-4 py-1.5 text-sm font-medium text-accent-200 backdrop-blur">
            <i className="ri-heart-line text-base"></i>
            关于我们
          </span>
          <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl">为每个爱漫画的人，<br /><span className="text-accent-300">点亮一本好漫</span></h1>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-200 md:text-lg">
            漫画岛是一个专注"发现好漫"的中文漫画推荐平台，致力于用编辑精选与每日推荐，帮每个人找到下一部值得入坑的作品。
          </p>
        </div>
      </section>

      <section className="bg-background-50 py-12 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
            <div>
              <p className="mb-2 flex items-center gap-2 text-sm font-bold text-primary-600">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>品牌故事
              </p>
              <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">我们为什么做「漫画岛」</h2>
              <div className="mt-5 flex flex-col gap-4 text-base leading-relaxed text-foreground-700">
                <p>面对海量的漫画作品，很多读者最头疼的问题不是"没得看"，而是"不知道看什么"——怕踩雷、怕烂尾、怕浪费宝贵的时间。</p>
                <p>于是我们创办了漫画岛：一支由资深漫画编辑组成的团队，带着"帮读者挖掘好货"的初心，日复一日地审读新作、追踪潜力佳作，把真正值得入坑的作品精挑细选出来。</p>
                <p>从编辑精选、每日推荐到新作尝鲜、分类总览，我们希望每一个打开漫画岛的人，都能轻松找到属于自己的下一部好漫，追更从此有方向。</p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {VALUES.map((v) => (
                <div key={v.title} className="rounded-2xl border border-background-200/70 bg-background-50 p-5">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                    <i className={`${v.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-4 font-bold text-foreground-950">{v.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-primary-500 py-12 md:py-16">
        <div className="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-4 text-center md:grid-cols-4 md:px-6">
          {[
            { num: '1280+', label: '精选好漫' },
            { num: '8', label: '内容分类' },
            { num: '365', label: '每日推荐' },
            { num: '99%', label: '读者好评' },
          ].map((s) => (
            <div key={s.label}>
              <p className="font-heading text-4xl text-background-50 md:text-5xl">{s.num}</p>
              <p className="mt-1 text-sm text-background-100/90">{s.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-background-100 py-12 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="mx-auto max-w-2xl text-center">
            <p className="mb-2 flex items-center justify-center gap-2 text-sm font-bold text-accent-600">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>读者口碑
            </p>
            <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">被读者信赖的「发现好漫」平台</h2>
            <p className="mt-3 text-base text-foreground-600">口碑，是我们最好的名片。</p>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
            {TESTIMONIALS.map((t) => (
              <figure key={t.name} className="flex flex-col rounded-2xl border border-background-200/70 bg-background-50 p-6">
                <div className="flex gap-0.5 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-base"></i>
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-base leading-relaxed text-foreground-700">「{t.text}」</blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-100 pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 text-lg text-secondary-700">
                    <i className="ri-user-smile-line"></i>
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-50 py-12 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
            <div>
              <p className="mb-2 flex items-center gap-2 text-sm font-bold text-primary-600">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>联系我们
              </p>
              <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">随时与我们交流</h2>
              <p className="mt-3 text-base leading-relaxed text-foreground-600">
                无论是作品投稿、合作洽谈，还是对我们有任何建议，都欢迎随时联系我们。我们期待听见你的声音。
              </p>
              <div className="mt-8 flex flex-col gap-4">
                {[
                  { icon: 'ri-mail-line', label: '电子邮箱', value: 'contact@manhuadao.cn' },
                  { icon: 'ri-phone-line', label: '联系电话', value: '+86 400-888-6666' },
                  { icon: 'ri-map-pin-line', label: '办公地址', value: '中国 · 上海市浦东新区世纪大道 88 号' },
                  { icon: 'ri-time-line', label: '工作时间', value: '周一至周五 9:00 - 18:00' },
                ].map((c) => (
                  <div key={c.label} className="flex items-center gap-4 rounded-xl border border-background-200/70 bg-background-50 p-4">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700">
                      <i className={`${c.icon} text-xl`}></i>
                    </span>
                    <div>
                      <p className="text-xs text-foreground-500">{c.label}</p>
                      <p className="text-sm font-bold text-foreground-950">{c.value}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-2xl border border-background-200/70 bg-background-100 p-6 md:p-8">
              <h3 className="font-heading text-2xl text-foreground-950">给我们留言</h3>
              <p className="mt-2 text-sm text-foreground-600">填写下方表单，我们会尽快与你联系。</p>
              <div className="mt-6">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}